class MusickitPreview
{
	static CurrentAudio;

	static init()
	{
		if(this.CurrentAudio !== undefined)
		{
			this.CurrentAudio.pause();
			this.CurrentAudio = undefined;
		}

		document.querySelectorAll('[data-music-kit-preview="1"]').forEach(function(element) {
			element.addEventListener('click', function(e) {
				e.preventDefault();

				var url = this.getAttribute("data-music-url");

				if (MusickitPreview.CurrentAudio && !MusickitPreview.CurrentAudio.paused) {
					MusickitPreview.CurrentAudio.pause();
				}

				MusickitPreview.CurrentAudio = new Audio(url);
				MusickitPreview.CurrentAudio.volume = 0.2;
				MusickitPreview.CurrentAudio.play();
			});
		});
	}
}

export default MusickitPreview;
